// Mock data for The 317 Foundation website

export const mockContactSubmit = async (formData) => {
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  const submissions = JSON.parse(localStorage.getItem('contactSubmissions') || '[]');
  const newSubmission = {
    ...formData,
    id: Date.now(),
    submittedAt: new Date().toISOString()
  };
  submissions.push(newSubmission);
  localStorage.setItem('contactSubmissions', JSON.stringify(submissions));
  
  console.log('Mock contact form submission:', newSubmission);
  return { success: true, message: 'Thank you! We will contact you soon.' };
};

export const coursesData = [
  {
    id: 'helpdesk',
    title: 'Help-Desk & End-User Support',
    icon: 'Wrench',
    description: 'Learn to troubleshoot and support users with technical issues',
    gradient: 'from-cyan-400 to-blue-500'
  },
  {
    id: 'hardware',
    title: 'Hardware & Network Fundamentals',
    icon: 'Network',
    description: 'Master the basics of computer hardware and networking',
    gradient: 'from-purple-400 to-pink-500'
  },
  {
    id: 'cloud',
    title: 'Cloud Basics (AWS & Azure)',
    icon: 'Cloud',
    description: 'Get started with leading cloud platforms and services',
    gradient: 'from-cyan-400 to-teal-500'
  },
  {
    id: 'ai',
    title: 'Intro to AI & Machine Learning',
    icon: 'BrainCircuit',
    description: 'Explore artificial intelligence and machine learning concepts',
    gradient: 'from-pink-400 to-purple-500'
  },
  {
    id: 'freelance',
    title: 'Freelance & Gig-Economy Readiness',
    icon: 'Briefcase',
    description: 'Prepare to work independently and build your client base',
    gradient: 'from-teal-400 to-green-500'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Dr. Charles Needham',
    initial: 'CN',
    role: 'DBA, Founder of C&M Educational Services',
    rating: 5,
    quote: 'With over 20 years of experience teaching courses online and face-to-face in business and management, I have seen firsthand how quality education can transform lives. The 317 Foundation\'s mission to provide accessible tech education aligns perfectly with my commitment to empowering students.',
    color: 'bg-cyan-500',
    credentials: '20+ Years Experience | 4 Degrees | Doctoral Committee Chair'
  },
  {
    id: 2,
    name: 'Dr. Maria Needham',
    initial: 'MN',
    role: 'DBA, Associate Professor & Youth Program Pioneer',
    rating: 5,
    quote: 'I created and pioneered the Summer Youth Entrepreneurship program and have seen how targeted education can increase student retention and success. With consistent 90%+ licensure exam pass rates, I believe in programs that deliver real results—just like The 317 Foundation.',
    color: 'bg-purple-500',
    credentials: 'Associate Professor | 150+ Students Advised Annually | 90%+ Pass Rates'
  }
];